// DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppGuard } from './app-guard.service';

import { AccessDeniedComponent } from './core/access-denied/access-denied.component';
import { HomeComponent } from './home/home.component';
import { SampleListComponent } from './sample/list/sample-list.component';
import { UserListComponent } from './user/list/user-list.component';
import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';
import { ComponentsComponent } from './components/components.component';
import { RescheduleComponent } from './reschedule/reschedule.component';
import { ScheduleComponent} from './schedule/schedule.component';
import { FaqComponent } from './components/faq/faq.component';

const routes: Routes = [
    {
        path: 'reschedule/:urlcode',
        component: RescheduleComponent,
        data: {
            title: 'Order Reschedule'
        }
    },
    {
        path: 'schedule',
        component: ScheduleComponent,
        data: {
            title: 'Order Schedule'
        },
        pathMatch: 'prefix'
    },
    {
        path: 'schedule/:ldc/:ordertype',
        component: ScheduleComponent,
        data: {
            title: 'Order Schedule'
        }
    },
    //{
    //    path: 'schedule/:ldc/:ordertype/:acntnumber',
    //    component: ScheduleComponent,
    //    data: {
    //        title: 'Order Schedule'
    //    }
    //},
    //{
    //    path: 'schedule/:ldc/:ordertype/:acntnumber/:urlsource',
    //    component: ScheduleComponent,
    //    data: {
    //        title: 'Order Schedule'
    //    }
    //},
    {
        path: 'faq/**',
       component: FaqComponent
    },
    {
        path: '',
       component: ComponentsComponent
    },
    {
        path: '**/:id',
        component: ComponentsComponent
    },
    {
        path: '**',
        component: ComponentsComponent
    },
    {
        path: '**/**',
        component: FaqComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }

